import tablelistApi from 'src/api/tablelistApi';

export default {
  findByIdAndOrganizationId(id, organizationId, options) {
    if (!id) throw new Error('id is required');
    if (!organizationId) throw new Error('organizationId is required');

    return tablelistApi.get(`/v1/organizations/${organizationId}/admission-group-stats/${id}`, options);
  },
  findByIdAndVenueId(id, venueId, options) {
    if (!id) throw new Error('id is required');
    if (!venueId) throw new Error('venueId is required');

    return tablelistApi.get(`/v1/venues/${venueId}/admission-group-stats/${id}`, options);
  }
};



// WEBPACK FOOTER //
// ./src/api/admissionGroupStat/service.js